var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon Station Public",
    viewBox: "0 0 10 16.661",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-publicstation-1{fill:currentColor}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i-publicstation-1",
    transform: "translate(3.279 3.539)",
    cx: 1.721,
    cy: 1.721,
    r: 1.721,
    "data-name": "Ellipse 1849"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i-publicstation-1",
    transform: "translate(-321.73 -143.06)",
    d: "M327.02 143.063h-5.287v11.49a3.635 3.635 0 0 0 3.138 3.589.621.621 0 0 0-.011.117v.843a.623.623 0 0 0 .621.621h2.5a.623.623 0 0 0 .621-.621v-.843a.616.616 0 0 0-.011-.117 3.635 3.635 0 0 0 3.138-3.589v-6.776a4.727 4.727 0 0 0-4.709-4.714zm3.035 11.324a2.074 2.074 0 0 1-2.068 2.068h-2.508a2.074 2.074 0 0 1-2.068-2.068v-9.469h3.766a2.886 2.886 0 0 1 2.878 2.878z",
    "data-name": "Pfad 13653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicStation);
export default __webpack_public_path__ + "static/media/publicStation.fe7a982a9ef2b6130921fcbdc760b9c1.svg";
export { ForwardRef as ReactComponent };